import config from './config';
import juratCrypto from './crypto';
import logger from './logger';
import storageHelper from './storage-helper';

const juratLocalStorage = {
  get(key) {
    if (!localStorage) {
      logger.error('Local storage does not exist');
      return null;
    }
    try {
      return config.cryptography
        ? JSON.parse(juratCrypto.decrypt(localStorage.getItem(key)) || null)
        : JSON.parse(localStorage.getItem(key) || null);
    } catch (e) {
      return null;
    }
  },

  set(key, val) {
    if (!localStorage) {
      logger.error('Local storage does not exist');
      return null;
    }
    try {
      return config.cryptography
        ? localStorage.setItem(key, juratCrypto.encrypt(JSON.stringify(val)))
        : localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {
      logger.error('Local storage error', e);
      return null;
    }
  },

  remove(key) {
    if (!localStorage) {
      logger.error('Local storage does not exist');
      return null;
    }

    return localStorage.removeItem(key);
  },

  clear() {
    if (!localStorage) {
      logger.error('Local storage does not exist');
      return null;
    }

    return localStorage.clear();
  },

  testStorage() {
    return storageHelper.storageAvailable('localStorage');
  }
};

export default juratLocalStorage;
